import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { InsurancePolicyTemplatesQuery } from 'app/graphql/generated/graphql-types';
import { CurrencyPipe } from 'app/pipes/currency';

type Coverage = InsurancePolicyTemplatesQuery['insurancePolicyTemplatesQuery'][0]['packages'][0]['coverages'][0];

@Pipe({
    name: 'stbyCellValue',
})
export class CellValuePipe implements PipeTransform {
    private readonly currencyPipe = inject(CurrencyPipe);
    private readonly translateService = inject(TranslateService);

    transform(dataRow: Coverage, isLatvia: boolean): string | null {
        const { coverage, amount, category } = dataRow;

        if (isLatvia) {
            return this.formatCellContent(coverage, amount, category);
        }

        if (coverage === 100 && amount === 0) {
            // null value indicates full coverage for Estonia and will be handled with a check-icon
            return null;
        }

        return `${this.currencyPipe.transform(amount)}`;
    }

    private formatCellContent(coverage: number, amount: number, category: string): string {
        const amountPerYear = `${this.currencyPipe.transform(amount)} ${this.translateService.instant(
            'profile.usergroup.insurance.new_policy.per_year',
        )}`;

        if (coverage && coverage !== 100 && amount) {
            return `${coverage} % (${this.translateService.instant(
                'profile.usergroup.insurance.new_policy.max',
            )} ${amountPerYear})`;
        } else if (coverage && !amount) {
            return `${coverage} %`;
        } else if (category === 'paidStationaryServices') {
            // Specific use-case for LV insurance
            return `${coverage} % (${amountPerYear})`;
        }

        return `${this.currencyPipe.transform(amount)}`;
    }
}
